const REGION_CALLING_CODES = {
  KE: '254',
  UG: '256'
} as const

type EventPreorderPhoneRegion = keyof typeof REGION_CALLING_CODES

const NATIONAL_PHONE_PATTERN = /^[1-9]\d{8}$/

export const normalizeEventPreorderPhone = (
  phone: string,
  regionCode: string
): string | null => {
  const compactPhone = phone.trim().replace(/[\s()-]/g, '')
  const digits = compactPhone.charAt(0) === '+' ? compactPhone.slice(1) : compactPhone

  if (!/^\d+$/.test(digits)) return null

  const explicitCallingCode = digits.startsWith(REGION_CALLING_CODES.KE)
    ? REGION_CALLING_CODES.KE
    : digits.startsWith(REGION_CALLING_CODES.UG)
      ? REGION_CALLING_CODES.UG
      : ''
  const currentRegion = regionCode.toUpperCase() as EventPreorderPhoneRegion
  const callingCode = explicitCallingCode || REGION_CALLING_CODES[currentRegion]

  if (!callingCode) return null

  let nationalNumber = explicitCallingCode ? digits.slice(explicitCallingCode.length) : digits
  if (nationalNumber.charAt(0) === '0') nationalNumber = nationalNumber.slice(1)

  return NATIONAL_PHONE_PATTERN.test(nationalNumber)
    ? `${callingCode}${nationalNumber}`
    : null
}
